import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-disconnected",
  "use": "icon-disconnected-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-disconnected\"><path d=\"M12 5.5v7.735L19.252 20H27v9h-9v-7.846L10.848 14.5H3v-9zM25 22h-5v5h5zM10 7.5H5v5h5zM24.5 3C26.9 3 29 5.1 29 7.5S26.9 12 24.5 12 20 9.9 20 7.5 22.1 3 24.5 3m0 2C23 5 22 6 22 7.5s1 2.5 2.5 2.5S27 9 27 7.5 26 5 24.5 5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol